<template>
  <div class="wrapper" :style="styles">
    <div :class="widgetClass">
      <div :class="wheadClasses">
        <div class="whead-left"
             :style="hover?wheadLeftHoverStyle:wheadLeftStyle"
             @mouseover="hover=true"
             @mouseout="hover=false">
          <slot name="head">
            <Icon :type="icon" :size="20" v-if="icon"></Icon>
            <span class="whead-left-title">{{title}}</span>
          </slot>
        </div>
        <div class="whead-right">
          <slot name="toolbar">
            <div class="head-close" @click="paasPageClose" v-if="closable">
              <Icon type="ios-close"  size="32" />
            </div>
          </slot>
        </div>
      </div>
      <div class="content" :style="contentStyle">
        <div class="no-data-span" v-if="noDataShow">
          <Icon type="iconfont iconwushuju" size="88" :color="titleColor"/>
          <h6  v-html="noDataTip"></h6>
        </div>
        <slot name="content">

        </slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "widget",
    data(){
      return {
        hover:false,
      }
    },
    props: {
      wbodyPadding:{
        type: String,  //body的间隙，用于table有点问题
        default: '10px'
      },
      offsetHeight:{
        type:[Number,String], //相对高度
        default:100,
      },
      title: {
        type: String,
      },
      icon: {
        type: String,  //功能icon，只支持icon
      },
      closable: {
        type: Boolean,  //显示关闭按钮
        default: true
      },
      noDataShow:{
        type: Boolean,  //数据默认不为空
        default: false
      },
      noDataTip: {
        type: String,  //数据为空时显示的提示内容
        default:"暂时木有内容呀～～"
      },
      titleColor:{
        type:String,
        default:'#ff552e',   //主要控制simple的标题和无数据的颜色样式
      },
      widgeType: {
        type:String,
        default: 'normal',  //有normal和simple
      },
      wrapperWidth: {
        type: [Number,String]
      },
    },
    computed: {
      /**
       * 计算wrapper的高度
       * */
      styles () {
        let style = {};
        if (this.wrapperWidth) {
          style['width'] = `${this.wrapperWidth}`;
        }
        return style;
      },
      /**
       * content 内容padding计算
       */
      contentStyle(){
        let style = {};
        style.padding = this.wbodyPadding;
        return style;
      },
      /**
       * class上加上simple或者normal
       */
      widgetClass:function(){
        return {
          "widget":true,
          ["widget-"+this.widgeType]:!!this.widgeType
        }
      },
      /**
       * class上加上simple或者normal
       */
      wheadClasses:function(){
        return {
          "whead":true,
          ["whead-"+this.widgeType]:!!this.widgeType
        }
      },
      /**
       * 用于计算simple title的颜色
       */
      wheadLeftStyle:function(){
        let style = {};
        if(this.titleColor && this.widgeType === "simple"){
          style.color = this.titleColor;
          style.borderBottom = "1px solid "+ this.titleColor;
        }
        return style;
      },
      /**
       * 用于计算simple 鼠标移动上去 title的颜色
       */
      wheadLeftHoverStyle:function(){
        let style = {};
        if(this.titleColor && this.widgeType === "simple"){
          style.color = this.titleColor;
          style.borderBottom = "2px solid "+ this.titleColor;
        }
        return style;
      }
    },
    methods:{
      /**
       * 点击关闭按钮
       */
      paasPageClose(){
        this.$emit("on-close");
      },
    },
  }
</script>

<style scoped>
  .wrapper{
    padding:10px;
    margin: 0px auto;
  }
  .widget {
    position: relative;
  }
  .widget-normal{
    background: #f7f7f7;
    border: 1px solid #cdcdcd;
    box-shadow: 0 2px 2px -2px #ccc;
    border-radius: 3px;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
  }
  .widget-simple{
    border:none;
    background: transparent;
    border-bottom: 1px solid #eee;
  }
  .whead {
    height:38px;
  }
  .whead-normal{
    /*! autoprefixer: off */
    color: #636363;
    background: #f8f8f8;
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#f8f8f8), color-stop(100%,#e8e8e8));
    background: -webkit-linear-gradient(top, #f8f8f8 0%,#e8e8e8 100%);
    background: -moz-linear-gradient(top, #f8f8f8 0%, #e8e8e8 100%);
    background: -o-linear-gradient(top, #f8f8f8 0%,#e8e8e8 100%);
    background: -ms-linear-gradient(top, #f8f8f8 0%,#e8e8e8 100%);
    background: linear-gradient(top, #f8f8f8 0%,#e8e8e8 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#6db5d5', endColorstr='#4a91c0',GradientType=0 );
  }
  .whead-simple{
    background:transparent;
  }
  .widget > [class*="whead-normal"] {
    border-bottom: 1px solid #cdcdcd;
    box-shadow: 0 1px 0 #fff;
    -webkit-box-shadow: 0 1px 0 #fff;
    -moz-box-shadow: 0 1px 0 #fff;
    text-shadow: 0 1px #fff;
    -webkit-border-top-right-radius: 3px;
    -webkit-border-top-left-radius: 3px;
    -moz-border-radius-topright: 3px;
    -moz-border-radius-topleft: 3px;
    position: relative;
  }
  .widget > [class*="whead-simple"] {
    border-bottom: 1px solid #eee;
    position: relative;
  }

  [class*="whead"]::after {
    display: block;
    clear: both;
  }
  .widget > [class*="whead"] .whead-left {
    float:left;
    padding: 8px 14px 7px 14px;
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
  }
  .widget > [class*="whead-simple"] .whead-left:hover{
    text-decoration: none;
    outline:0
  }
  .widget > [class*="whead"] .whead-right{
    float:right;
  }
  .head-close{
    width: 50px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    float: right;
    cursor: pointer;
    margin: -8px -14px -7px -14px;
  }
  .head-close:hover{
    background:red;
    color:#ffffff;
  }

  .widget > [class*="content"]{
    text-align:center;
    min-height:200px;
    margin:0px auto;
    width:100%;
  }
  .no-data-span{
    margin:30px auto;
  }
  .no-data-span > h6{
    color: #666;
    margin-top: 20px;
    font-size:16px;
  }
  /*发现table的默认样式为inherit，如果content的padding为0会有问题*/
  .widget >>> [class*="ivu-table"]{
    width:100%;
  }
  .toolbar-btn{
    width: 60px;
    height: 28px;
    margin-top: -3px;
  }
</style>
